"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Backdrop", {
    enumerable: true,
    get: function() {
        return Backdrop;
    }
});
var _accelerator = /*#__PURE__*/ _interopRequireDefault(require("../Router/Accelerator"));
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var Backdrop = /*#__PURE__*/ function() {
    "use strict";
    function Backdrop() {
        _classCallCheck(this, Backdrop);
        this.on = function() {};
        this.fire = function() {};
        if (Backdrop._instance) {
            return Backdrop._instance;
        }
        if (!this.doesBackdropExist()) {
            this.createBackdrop();
        }
        var accelerator = new _accelerator.default();
        this.on = accelerator.subscribe.bind(accelerator);
        this.fire = accelerator.publish.bind(accelerator);
        this.backdrop = document.querySelector(".wr-backdrop");
        this.addEventListeners();
        Backdrop._instance = this;
    }
    var _proto = Backdrop.prototype;
    _proto.addEventListeners = function addEventListeners() {
        this.backdrop.addEventListener("click", this.clickHandler.bind(this));
        document.addEventListener("keydown", this.keyPressHandler.bind(this));
        this.on("close", this.hideBackdrop.bind(this));
        this.on("backdrop:close", this.hideBackdrop.bind(this));
        this.on("hide", this.hideBackdrop.bind(this));
        this.on("backdrop:hide", this.hideBackdrop.bind(this));
        this.on("open", this.showBackdrop.bind(this));
        this.on("backdrop:open", this.showBackdrop.bind(this));
        this.on("show", this.showBackdrop.bind(this));
        this.on("backdrop:show", this.showBackdrop.bind(this));
    };
    _proto.doesBackdropExist = function doesBackdropExist() {
        return !!document.querySelector(".wr-backdrop");
    };
    _proto.isBackdropVisible = function isBackdropVisible() {
        return this.backdrop.classList.contains("show") || this.backdrop.hasAttribute("open") && this.backdrop.getAttribute("open") === "true";
    };
    _proto.createBackdrop = function createBackdrop() {
        var div = document.createElement("div");
        div.classList.add("wr-backdrop", "custom-backdrop", "backdrop");
        document.body.appendChild(div);
        this.fire("backdrop-created", {
            element: div,
            backdrop: this
        });
        this.fire("backdrop:created", {
            element: div,
            backdrop: this
        });
    };
    _proto.showBackdrop = function showBackdrop() {
        if (this.isBackdropVisible()) {
            return;
        }
        this.backdrop.classList.remove("hidden");
        this.backdrop.classList.add("show");
        this.backdrop.setAttribute("open", "true");
        document.body.dispatchEvent(new CustomEvent("wr-backdrop-shown", {
            detail: {
                element: this.backdrop,
                backdrop: this
            }
        }));
    };
    _proto.hideBackdrop = function hideBackdrop() {
        if (!this.isBackdropVisible()) {
            return;
        }
        this.backdrop.classList.add("hidden");
        this.backdrop.classList.remove("show");
        this.backdrop.setAttribute("open", "false");
        document.body.dispatchEvent(new CustomEvent("wr-backdrop-hidden", {
            detail: {
                element: this.backdrop,
                backdrop: this
            }
        }));
    };
    /**
     * @deprecated use the fire function.
     *
     * @see Backdrop.fire
     * @noop
     * @param func
     */ _proto.addCustomClickHandler = function addCustomClickHandler(func) {};
    _proto.keyPressHandler = function keyPressHandler(e) {
        this.fire("keypress", e);
        if (e.repeat) {
            return;
        }
        if ([
            "Escape"
        ].includes(e.key)) {
            this.fire("backdrop:close");
        }
    };
    _proto.clickHandler = function clickHandler(e) {
        this.fire("backdrop:click", e);
        this.fire("backdrop:close");
    };
    Backdrop.getInstance = function getInstance() {
        if (Backdrop._instance) {
            return Backdrop._instance;
        }
        return new Backdrop();
    };
    return Backdrop;
}();
